import { makeStyles } from '@material-ui/core/styles';

import { topNavHeight } from '../top-nav/TopNavStyles';

export const sideNavWidth = 287;
const sideNavFooterHeight = 74.5;

const useStyles = makeStyles((theme) => ({
    root: {
        ...theme.mixins.flex.shrink(0),

        width: sideNavWidth,
        backgroundColor: theme.palette.background.paper,

        '& .MuiDrawer-paper': {
            top: topNavHeight,
            width: sideNavWidth,
            height: `calc(100% - ${topNavHeight}px)`,
        },

        '&.floating': {
            '& .MuiDrawer-paper': {
                top: 0,
                height: '100%',
                boxShadow: theme.shadows[9],
            },
        },

        '@media print': {
            display: 'none',
        },
    },

    scrollContainer: {
        backgroundColor: theme.palette.background.paper,
    },

    footer: {
        height: sideNavFooterHeight,
        maxHeight: sideNavFooterHeight,
        minHeight: sideNavFooterHeight,
        ...theme.mixins.flex.grow(0),
        ...theme.mixins.flex.shrink(0),
        ...theme.mixins.flex.justifyContentCenter,
        ...theme.mixins.flex.alignItemsCenter,
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
    },

    companyLogo: {
        width: 162,
    },
}));

export default useStyles;
